import VueTimepicker from 'vue2-timepicker';

import * as headerBlock from '../header/';

export default  {
  name: 'shifts',
  components: { headerBlock, VueTimepicker },
  props: [
    'onLogout',
    'access_token',
    'authUser',
  ],
  mounted() {

  },
  data() {
    return {
      currentItem: {
        key: null,
        index: null,
      },
      timeStart: {
        HH: '00',
        mm: '00',
      },
      timeEnd: {
        HH: '00',
        mm: '00',
      },
      addShiftStr: '+ add shifts',
      breadCrumbItems: [
        {
          text: 'Home',
          to: `${process.env.START_URL}/`,
        }, {
          text: 'Days, times, shifts',
          active: true,
        },
      ],
      items: [],
      itemsArea: [],
      fields: {
        monday: {
          label: 'Monday',
          value: 2,
          class: 'td',
        },
        tuesday: {
          label: 'Tuesday',
          value: 3,
          class: 'td',
        },
        wednesday: {
          label: 'Wednesday',
          value: 4,
          class: 'td',
        },
        thursday: {
          label: 'Thursday',
          value: 5,
          class: 'td',
        },
        friday: {
          label: 'Friday',
          value: 6,
          class: 'td',
        },
        saturday: {
          label: 'Saturday',
          value: 7,
          class: 'td',
        },
        sunday: {
          label: 'Sunday',
          value: 1,
          class: 'td',
        },
      },
      shifts: null,
      shiftsArea: null,
      areaId: null,
      custom_shifts: false,
      toogleCompanyShifts: 1,
      toogleCompanyShiftsOptions: [{
        text: 'Company shifts',
        value: 1,
      }, {
        text: 'Area shifts',
        value: 2,
      }],
      emptyShifts: {
        monday: [],
        tuesday: [],
        wednesday: [],
        thursday: [],
        friday: [],
        saturday: [],
        sunday: [],
      },
    };
  },
  methods: {
    log(str) {
      console.log(str);
    },
    resetTimes() {
      this.timeStart = { HH: '06', mm: '00' };
      this.timeEnd = { HH: '06', mm: '00' };
    },
    makeTimesFromString(str) {
      var times = str.split('-');
      this.timeStart = { HH: times[0].split(':')[0], mm: times[0].split(':')[1] };
      this.timeEnd = { HH: times[1].split(':')[0], mm: times[1].split(':')[1] };
    },
    onClickAddShift(key) {
      // this.shifts[key].push(this.timeStart.HH + ':' + this.timeStart.mm + '-' +
      //                       this.timeEnd.HH + ':' + this.timeEnd.mm);
      this.sendNewShift(key, [this.timeStart.HH + ':' + this.timeStart.mm, this.timeEnd.HH + ':' + this.timeEnd.mm]);
      // this.updateTableData();
    },
    onClickDelete(key, index) {
      // this.shifts[key].splice(index, 1);
      // this.updateTableData();
      this.sendDeleteShift(key, index);
    },
    onClickEdit(key, index) {
      // this.shifts[key][index] = this.timeStart.HH + ':' + this.timeStart.mm + '-' +
      //                           this.timeEnd.HH + ':' + this.timeEnd.mm;
      // this.updateTableData();
      this.sendEditShift(key, index,
        {
          start: this.timeStart.HH + ':' + this.timeStart.mm,
          end: this.timeEnd.HH + ':' + this.timeEnd.mm,
        });
    },
    sortShifts(shifts) {
      shifts.sort(function(a, b) {
        if (a.start == b.start) {
          return a.end > b.end;
        }
        return a.start > b.start;
      });
    },
    updateTableData() {
      this.items = [];
      for (var key in this.shifts) {
        for (var i = 0; i < this.shifts[key].length; i++) {
          if (this.items.length <= i) {
            this.items.push({});
          }
          this.items[i][key] = this.shifts[key][i].time;
        };
        if (this.items.length <= this.shifts[key].length) {
          this.items.push({});
        }
        // this.items[this.shifts[key].length][key] = this.addShiftStr;
      }
    },
    updateTableDataArea() {
      this.itemsArea = [];
      for (var key in this.shiftsArea) {
        for (var i = 0; i < this.shiftsArea[key].length; i++) {
          if (this.itemsArea.length <= i) {
            this.itemsArea.push({});
          }
          this.itemsArea[i][key] = this.shiftsArea[key][i].time;
        }
        if (this.itemsArea.length <= this.shiftsArea[key].length) {
          this.itemsArea.push({});
        }
        // this.items[this.shifts[key].length][key] = this.addShiftStr;
      }
    },
    sendDeleteShift(key, index) {
      let shiftId = 0;
      if (!this.areaId) {
        shiftId = this.shifts[key][index].id;
      } else {
        shiftId = this.shiftsArea[key][index].id;
      }
      this.$http.patch('shifts/' + shiftId + '/', { is_active: false },
        {
          method: 'PATCH',
          headers: {
            Authorization: `Token ${this.access_token}`,
          },
          // emulateJSON: true,
        })
        .then((response) => {
          if (response.status !== 200) {
            console.log(response);
            return;
          }
          this.getShiftList(this.areaId);
        })
        .catch((response) => {
          if (response.status === 401) {
            this.onLogout();
          }
        });
    },
    sendEditShift(key, index, time) {
      var data = {
        // id: this.shifts[key][index].id,
        // day: this.fields[key].value,
        start: time.start,
        end: time.end,
      }
      let shiftId = 0;
      if (!this.areaId) {
        shiftId = this.shifts[key][index].id;
      } else {
        shiftId = this.shiftsArea[key][index].id;
      }
      this.$http.patch('shifts/' + shiftId + '/', data,
        {
          method: 'PATCH',
          headers: {
            Authorization: `Token ${this.access_token}`,
          },
          // emulateJSON: true,
        })
        .then((response) => {
          if (response.status !== 200) {
            console.log(response);
            return;
          }
          this.getShiftList(this.areaId);
        })
        .catch((response) => {
          if (response.status === 401) {
            this.onLogout();
          }
        });
    },
    sendNewShift(key, times) {
      var data = {
        day: this.fields[key].value,
        start: times[0],
        end: times[1],
        area: this.areaId,
      }
      if (this.$route.params.companyId) {
        data.company = this.$route.params.companyId;
      }
      this.$http.post('shifts/', data,
        {
          method: 'POST',
          headers: {
            Authorization: `Token ${this.access_token}`,
          },
          // emulateJSON: true,
        })
        .then((response) => {
          if (response.status !== 201) {
            console.log(response);
            return;
          }
          this.getShiftList(this.areaId);
        })
        .catch((response) => {
          if (response.status === 401) {
            this.onLogout();
          }
        });
    },
    getShiftList(areaId) {
      let url = 'shifts/';
      if (areaId) {
        url = `${url}?area=${areaId}`;
      } else {
        if (this.$route.params.companyId) {
          url = `${url}?company=${this.$route.params.companyId}`;
        }
      }

      this.$http.get(url,
          {
            method: 'GET',
            headers: {
              Authorization: `Token ${this.access_token}`,
            },
            // emulateJSON: true,
          })
          .then((response) => {
            if (response.status !== 200) {
              console.log(response);
              return;
            }
            if (!areaId) {
              this.shifts = JSON.parse(JSON.stringify(this.emptyShifts));
            } else {
              this.shiftsArea = JSON.parse(JSON.stringify(this.emptyShifts));
            }
            this.sortShifts(response.body);
            for (var i = 0; i < response.body.length; i++) {
              for (var key in this.fields) {
                if (this.fields[key].value == response.body[i].day) {
                  let time = response.body[i].start.split(':')[0] + ':' + response.body[i].start.split(':')[1] + '-' +
                             response.body[i].end.split(':')[0] + ':' + response.body[i].end.split(':')[1]
                  let newData = {
                    id: response.body[i].id,
                    time: time,
                  };
                  if (!areaId) {
                    if (!response.body[i].area) {
                      this.shifts[key].push(newData);
                    }
                  } else {
                    this.shiftsArea[key].push(newData);
                  }
                }
              }
            }
            if (!areaId) {
              this.updateTableData();
            } else {
              this.updateTableDataArea();
            }
          })
          .catch((response) => {
            if (response.status === 401) {
              this.onLogout();
            }
          });
    },
    changeWorkingAreaCustomShift() {
      console.log('change custom', this.custom_shifts, this.toogleCompanyShifts === 2);
      // return;
      this.$http.patch(`areas/${this.areaId}/`, { custom_shifts: this.toogleCompanyShifts === 2 },
        {
          method: 'PATCH',
          headers: {
            Authorization: `Token ${this.access_token}`,
          },
          // emulateJSON: true,
        })
        .then((response) => {
          if (response.status !== 200) {
            console.log(response);
            // that.$set(that, 'moduleError', true);
            return;
          }
          return response;
        })
        .catch((response) => {
          if (response.status === 401) {
            this.onLogout();
          }
        });
    },
  },
  computed: {

  },
  created() {
    this.shifts = JSON.parse(JSON.stringify(this.emptyShifts));
    this.shiftsArea = JSON.parse(JSON.stringify(this.emptyShifts));
    this.areaId = (this.$route.params.areaId)?this.$route.params.areaId:null;
    this.custom_shifts = this.$route.params.custom_shifts;
    if (this.custom_shifts === true) {
      this.toogleCompanyShifts = 2;
    }
    // this.items.push(
    //   {
    //     monday: this.addShiftStr,
    //     tuesday: this.addShiftStr,
    //     wednesday: this.addShiftStr,
    //     thursday: this.addShiftStr,
    //     friday: this.addShiftStr,
    //     saturday: this.addShiftStr,
    //     sunday: this.addShiftStr,
    //   },
    // );
    this.updateTableData();
    this.updateTableDataArea();
    this.getShiftList();
    if (this.areaId) {
      this.getShiftList(this.areaId);
    }
  },
  watch: {
    toogleCompanyShifts() {
      this.changeWorkingAreaCustomShift();
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/shifts/shifts.component.js